module.exports = __webpack_public_path__ + "img/hk1_mainland_quotaIcon.047eb486.png";